import { TimeUnit } from '@mews/enums';
import { DENSITY, DENSITY_PERCENTAGE } from '../constants';
import { CHANGE_DENSITY, CHANGE_DENSITY_PERCENTAGE, CHANGE_TIME_UNIT } from '../actions/types';

export const NAME = 'timelineView';

interface TimelineViewState {
    selectedDensity: string;
    selectedDensityPercentage: number;
    selectedTimeUnit: TimeUnit;
}

const initialState: TimelineViewState = {
    selectedDensity: DENSITY.SPACIOUS,
    selectedDensityPercentage: DENSITY_PERCENTAGE['100'],
    selectedTimeUnit: TimeUnit.Day,
};

export default function timelineViewReducer(state = initialState, action: $TSFixMe) {
    switch (action.type) {
        case CHANGE_DENSITY:
            return {
                ...state,
                selectedDensity: action.payload,
            };
        case CHANGE_DENSITY_PERCENTAGE:
            return {
                ...state,
                selectedDensityPercentage: action.payload,
            };
        case CHANGE_TIME_UNIT:
            return {
                ...state,
                selectedTimeUnit: action.payload,
            };
        default:
            return state;
    }
}
